export const classes = {
  card: 'relative h-full grow min-w-[240px] flex flex-col overflow-hidden px-3 pt-0 bg-white/40 dark:bg-white/5',
  tabs: 'flex flex-col grow min-h-0',
  tabsBody: 'grow min-h-0 overflow-y-auto',
  headerControls: 'absolute top-2 right-1 z-10 flex items-center',
  closeIcon: 'text-taupe-2 dark:text-mauve-2',
  footer: 'shrink-0 flex justify-end pt-2 pb-1',
  condensedCard: 'h-full w-full overflow-hidden p-1 bg-transparent shadow-none',
};
